import { Core } from "@faire/design-tokens";
import styled from "styled-components";

export const IconWrapper = styled.div`
  border-radius: 50%;
  padding: 24px;
  background: ${Core.surface.subdued};
  width: 72px;
  height: 72px;
  text-align: center;
`;
